import { lazy } from 'react'

import type { RouteObject } from 'react-router'

import { ConfiguracoesParametrosPageSuspense } from '@/features/configuracoes/brasil/pages/parametros/suspense'
import { ConfiguracoesReservaPageSuspense } from '@/features/configuracoes/brasil/pages/reserva/suspense'

const ConfiguracoesCoresLotesPage = lazy(() =>
  import('@/features/configuracoes/brasil/pages/cores-lotes').then((module) => ({
    default: module.ConfiguracoesCoresLotesPage,
  })),
)

const ConfiguracoesReservaPage = lazy(() =>
  import('@/features/configuracoes/brasil/pages/reserva').then((module) => ({
    default: module.ConfiguracoesReservaPage,
  })),
)

const ConfiguracoesParametrosPage = lazy(() =>
  import('@/features/configuracoes/brasil/pages/parametros').then((module) => ({
    default: module.ConfiguracoesParametrosPage,
  })),
)

const ConfiguracoesPerfilPage = lazy(() =>
  import('@/features/configuracoes/brasil/pages/perfil').then((module) => ({
    default: module.ConfiguracoesPerfilPage,
  })),
)

const ConfiguracoesTermosPage = lazy(() =>
  import('@/features/configuracoes/brasil/pages/termos').then((module) => ({
    default: module.ConfiguracoesTermosPage,
  })),
)

export const brasilConfiguracoesRoutes: RouteObject[] = [
  {
    path: 'configuracoes',
    children: [
      {
        path: 'cores-lotes',
        element: <ConfiguracoesCoresLotesPage />,
      },
      {
        path: 'reserva',
        element: (
          <ConfiguracoesReservaPageSuspense>
            <ConfiguracoesReservaPage />
          </ConfiguracoesReservaPageSuspense>
        ),
      },
      {
        path: 'parametros',
        element: (
          <ConfiguracoesParametrosPageSuspense>
            <ConfiguracoesParametrosPage />
          </ConfiguracoesParametrosPageSuspense>
        ),
      },
      {
        path: 'perfil',
        element: <ConfiguracoesPerfilPage />,
      },
      {
        path: 'termos',
        element: <ConfiguracoesTermosPage />,
      },
    ],
  },
]
